import {
  GET_STAFF_LEAVE_TYPE,
  GET_STAFF_LEAVE_TYPE_SUCCESS,
  GET_STAFF_LEAVE_TYPE_ERROR,
  GET_STAFF_LEAVE_LIST,
  GET_STAFF_LEAVE_LIST_SUCCESS,
  GET_STAFF_LEAVE_LIST_ERROR,
} from "./actionType";

// Action Calendar Staff Leave List
export const getStaffLeaveList = () => {
  return {
    type: GET_STAFF_LEAVE_LIST,
  };
};

export const getStaffLeaveListSuccess = (staffLeaveList) => {
  return {
    type: GET_STAFF_LEAVE_LIST_SUCCESS,
    payload: staffLeaveList,
  };
};

export const getStaffLeaveListError = (error) => {
  return {
    type: GET_STAFF_LEAVE_LIST_ERROR,
    payload: error,
  };
};

// Action Calendar Staff Leave Type
export const getStaffLeaveType = () => {
  return {
    type: GET_STAFF_LEAVE_TYPE,
  };
};

export const getStaffLeaveTypeSuccess = (staffLeaveType) => {
  return {
    type: GET_STAFF_LEAVE_TYPE_SUCCESS,
    payload: staffLeaveType,
  };
};

export const getStaffLeaveTypeError = (error) => {
  return {
    type: GET_STAFF_LEAVE_TYPE_ERROR,
    payload: error,
  };
};
